import { render, staticRenderFns } from "./FeedbackStatByCaseType.vue?vue&type=template&id=68085ed9&"
import script from "./FeedbackStatByCaseType.vue?vue&type=script&lang=js&"
export * from "./FeedbackStatByCaseType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports